export default __webpack_public_path__ + "static/media/drag_and_drop.e69b92b9.png";